import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AssistantHeroComponent } from '../../components/panorama/assistant-hero/assistant-hero.component';
import { HOME_HERO } from '../../constants/layout.constants';

/**
 * Home page.
 *
 * Previously fetched the `home` Storyblok story and rendered it through
 * `ndc-dynamic` → `HomePageComponent` → the hero block. The story's entire
 * content was the four strings now in `HOME_HERO`, so the hero renders directly
 * and the skeleton is gone with the request it was covering for.
 *
 * The hero is now `inexp-assistant-hero` — one "Ask Panorama" field plus
 * starter prompts, all of which run a catalog search. The old `inexp-hero`
 * stays registered as the Storyblok `hero` block and is untouched.
 */
@Component({
  selector: 'inexp-home',
  imports: [AssistantHeroComponent],
  templateUrl: './home.component.html',
  styleUrl: './home.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeComponent {
  readonly hero = HOME_HERO;
}
